import { render, staticRenderFns } from "./CreatePriceVersion.vue?vue&type=template&id=74c6e116&scoped=true&"
import script from "./CreatePriceVersion.vue?vue&type=script&lang=js&"
export * from "./CreatePriceVersion.vue?vue&type=script&lang=js&"
import style0 from "./CreatePriceVersion.vue?vue&type=style&index=0&id=74c6e116&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c6e116",
  null
  
)

export default component.exports